import React from "react";
import BlogBVCITS from "../../assets/blog_img/bvcits_logo.png";
import BlogVignan from "../../assets/blog_img/vignan_logo.png";
import "./blogs.css";

const Blog = () => {
  return (
    <div className="blog-container">
      <div className="blog-content">
        <div className="blog-card">
          <a href="/aspiron technologies-blog-1-Vignan Institute of Technology case study">
            <img src={BlogVignan} className="blog-image" alt="Vignan Institute" />
          </a>
          <div className="blog-details">
            <p className="blog-title">
              Vignan Institute of Technology and Science
            </p>
            <p className="blog-description">
              During times of transformation, those who embrace learning gain the future, while those clinging to past knowledge are left prepared for a reality that has already vanished. – Paraphrase of Eric Hoffer
            </p>
          </div>
        </div>

        <div className="blog-card">
          <a href="/aspiron technologies-blog-2-Bonam Venkata Chalamayya Engineering College-BVCS-case study">
            <img src={BlogBVCITS} className="blog-image" alt="BVCITS" />
          </a>
          <div className="blog-details">
            <p className="blog-title">
              Bonam Venkata Chalamayya Engineering College
            </p>
            <p className="blog-description">
              In times of change, learners inherit the earth, while the learned find themselves beautifully equipped to deal with a world that no longer exists. – Eric Hoffer
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
